import {call,put,takeEvery,take} from 'redux-saga/effects';
import axios from 'axios';
import {setCookie,getCookie} from '../../Components/HelperFunctions/CookieSettings'
import ApiData from './ApiData.json';

function GetCalculatedResultsAPI(action)
{
    const requestBody = action.payload ;
    let http = `${ApiData.BaseApiLink}/Report/GetCalculatedResults?filterId=2&filterValue=`+requestBody.studentId;

    return axios.get(http,
    { headers:{Authorization:'Bearer '+getCookie('domockexamToken'),"Content-Type":"application/json"}})
    .then((res)=>{
       //console.log('GetCalculatedResults')
        return res.data;
    })
    .catch((err)=>{
        console.log('err-GetCalculatedResultsAPI:',err);
    });
}

function* GetCalculatedResultsAPIWorkerSaga(action)
{
    try{
            const Result = yield call(GetCalculatedResultsAPI,action);
            console.log('GetCalculatedResults',Result);
            yield put({type:'GET_CALCULATED_RESULTS',payload:Result.value})
    }
    catch(e)
    {

    }
}

export function* GetCalculatedResultsAPISaga()
{
    yield takeEvery('GET_CALCULATED_RESULT_REQUESTED',GetCalculatedResultsAPIWorkerSaga)
}